import { MONTHLY_CHECK_SUBMISSTION_STATUS } from "./enums";

const MONTHLY_CHECK_SUBMISSION_STATUS_LABEL = {
  [MONTHLY_CHECK_SUBMISSTION_STATUS.ANSWERED]: "回答済",
  [MONTHLY_CHECK_SUBMISSTION_STATUS.UNANSWERED]: "未回答",
};

const MONTHLY_CHECK_SUBMISSION_STATUS_STYLES = {
  [MONTHLY_CHECK_SUBMISSTION_STATUS.UNANSWERED]: {
    title:
      MONTHLY_CHECK_SUBMISSION_STATUS_LABEL[
        MONTHLY_CHECK_SUBMISSTION_STATUS.UNANSWERED
      ],
    className: "bg-grey-600 size-2 rounded-full",
  },
  [MONTHLY_CHECK_SUBMISSTION_STATUS.ANSWERED]: {
    title:
      MONTHLY_CHECK_SUBMISSION_STATUS_LABEL[
        MONTHLY_CHECK_SUBMISSTION_STATUS.ANSWERED
      ],
    className: "bg-primary_light size-2 rounded-full",
  },
};

export {
  MONTHLY_CHECK_SUBMISSION_STATUS_LABEL,
  MONTHLY_CHECK_SUBMISSION_STATUS_STYLES,
};
